import { Component, OnInit } from '@angular/core';
import { LevelState } from './model/levelState';
import { LevelService } from './services/levelService';
import { GameService } from './services/gameService';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StateService } from './services/stateService';
import { AnalyticsService } from './services/analyticsService';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'xn-app',
    templateUrl: 'app.html',
    styleUrls: ['app.scss'],
})
export class AppComponent implements OnInit {

    public brandLogoSource = 'assets/heart.png';
    public brandName = 'u&i - sokoban';

    public currentLevelState$: Observable<LevelState>;
    public currentLevel$: Observable<number>;
    public localProfile$: Observable<any>;

    public present: number = null;

    public constructor(private _gameService: GameService,
                       private _stateService: StateService,
                       private _router: Router,
                       private _analytics: AnalyticsService,
                       private _levelService: LevelService) {
    }

    public ngOnInit(): void {
        this._router
            .events
            .subscribe((event: NavigationEnd) => {
                if (event instanceof NavigationEnd) {
                    this._analytics.trackPageView({url: event.urlAfterRedirects});
                }
            });
        this.currentLevelState$ = this._gameService.levelState;
        this.currentLevel$ = this._levelService.currentLevel;
        this.getLocalProfile();
    }

    public nextLevel() {
        this._levelService.nextLevel();
    }

    public restartGame() {
        this._levelService.setLevel(1);
    }

    public replay() {
        this._gameService.replayLevel();
    }

    public acknowledgeTutorial() {
        this._stateService.writeState('firstTime', false);
        this.getLocalProfile();
    }

    private getLocalProfile() {
        this.localProfile$ = this._stateService
            .getStoredData('firstTime')
            .pipe(
                map(firsttime => { return {firstTime: !!firsttime}; })
            );
    }

    public setPresent(present: number) {
        this.present = present;
    }

    public closePresent() {
        this.present = null;
    }

}
